<template>
  <v-dialog v-model="dialog" max-width="960px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("Economies.result.title") }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-4 py-8 text-center subtitle-1">
        <v-data-table
          :headers="headers"
          :items="errorEconomies"
          multi-sort
          class="elevation-1 px-4 pt-2"
          disable-pagination
          hide-default-footer
          fixed-header
        >
          <template v-slot:item.error_type="{ item }">
            <span class="red--text" v-if="item.error_type == 'enabled'">
              {{ $t("Economies.result.enabled") }}
            </span>
            <span class="red--text" v-else-if="item.error_type == 'change'">
              {{ $t("Economies.result.change") }}
            </span>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn color="accent" @click="confirm()">
          {{ $t("Economies.result.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

import {mapState} from "vuex";
import Economies from "@/api/economies";
import i18n from "@/i18n";

export default {
  name: "CompleteResultDialog",

  props: {
    value: Boolean,
    errorEconomies: Array,
    economy: Object
  },
  computed: {
    headers: () => [
      {
        text: i18n.t("Economies.result.category_name"),
        align: "start",
        sortable: false,
        value: "category_name",
      },
      {
        text: i18n.t("Economies.result.material_code"),
        align: "start",
        sortable: false,
        value: "material_code",
      },
      {
        text: i18n.t("Economies.result.material_name"),
        align: "start",
        sortable: false,
        value: "material_name",
      },
      {
        text: i18n.t("Economies.result.error_type"),
        align: "start",
        sortable: false,
        value: "error_type",
      },
    ],
    ...mapState(["loading", "settings"]),
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    confirm() {
      this.economy = Object.assign({},this.economy, {
        confirm: true,
      });
      Economies.complete(this.economy.id, this.economy).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.dialog = false
            this.$router.push("/economies");
          }
        }.bind(this)
      );
    }
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
        console.log('errorEconomies', this.errorEconomies)
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
      },
    },
  },
};
</script>